import { setCurrentUser } from '@src/redux/modules/auth'

export default function setCurrentUserToUserId (store) {
  return (nextState, replace, next, finish) => {
    const { userId } = nextState.params

    store.dispatch(
      setCurrentUser(userId)
    )

    return next()
  }
}



// WEBPACK FOOTER //
// ./src/routes/middleware/setCurrentUserToUserId.js